import { Box, ButtonBase, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import AppBarContainer from "../../components/shared/AppBarContainer";
import { ReactComponent as NotifIcon } from "../../assets/icons/notif-icon.svg";
import PageContentContainer from "../../components/shared/PageContentContainer";
import AssetsPast from "../../components/assets/AssetsPast";
import AssetsToday from "../../components/assets/AssetsToday";
import { useNavigate } from "react-router-dom";

function AssetsPage() {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  return (
    <>
      <AppBarContainer
        rightElement={
          <Typography variant="h5" color={"common.white"}>
            دارایی
          </Typography>
        }
        leftElement={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              onClick={() => {
                navigate("/app/messages");
              }}
              sx={{ display: "flex", alignItems: "center", ml: "8px" }}
            >
              <NotifIcon />
            </Box>
          </Box>
        }
      />
      <Box
        sx={{
          width: "100%",
          position: "relative",
          zIndex: 1,
          mb: "-40px",
          px: "24px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            p: "4px",
            boxShadow: (theme) => theme.shadows[2],
            bgcolor: "common.white",
            borderRadius: "8px",
          }}
        >
          {[{ title: "امروز" }, { title: "تاریخچه" }].map((item, index) => {
            const isActive = activeIndex === index;
            return (
              <ButtonBase
                key={item.title}
                onClick={() => {
                  setActiveIndex(index);
                }}
                sx={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "6px",
                  bgcolor: isActive ? "grey.2" : "common.white",
                  height: 32,
                }}
              >
                <Typography
                  variant="h5"
                  color={isActive ? "common.white" : "grey.4"}
                >
                  {item.title}
                </Typography>
              </ButtonBase>
            );
          })}
        </Box>
      </Box>
      <PageContentContainer
        id="ordersScrollable"
        sx={{
          mt: "20px",
          overflow: "auto",
          pt: 4,
          display: "block",
        }}
      >
        {activeIndex === 0 ? <AssetsToday /> : <AssetsPast />}
      </PageContentContainer>
    </>
  );
}

export default AssetsPage;
